module.exports={
    "global": [
        "quickView",
        "selectItem",
        "varientClick",
        "colourClick",
        "lengthClick",
        "navigationClick",
        "viewCart",
        "removeItemsFromCart",
        "addItemsToCart",
        "previewMiniBag",
        "closeMiniPreviewBag",
        "productContextMenuOpen",
        "beginCheckout",
        "addShippingInfo",
        "loginPage",
        "registerPage",
        "subscribeFooterSection",
        "subscribeCheckboxSection",
        "subscribePDPNotifyPopup",
        "formValidationErrors",
        "findStore",
        "subscribeFooterError",
        "viewItemList",
        "searchSelectItem",
        "viewCartBag",
        "filtersClick",
        "genreClick",
        "landingClick",
        "internalSearch",
        "internalSearchCategoryClick",
        "searchResultsClick",
        "navBannerClick",
        "clpBannerClick",
        "navHktBannerClick",
        "addtobagProductTile",
        "socialFooterClick",
        "landingBannerClick",
        "quickShopAddItemsToCart",
        "denimClick"
    ],
    "productSet": [
        "shareClick"
    ],
    "cart": [
        "couponCode"
    ],
    "checkout": [
        "shippingSubmit",
        "shippingMethodChange",
        "addPaymentInfo",
        "couponCode",
        "globale",
        "paymentPageError",
        "formCehckoutValidationErrors",
        "formBillingValidationErrors",
        "checkoutGoPayment",
        "checkoutPlaceOrder",
        "loginPageError"
    ],
    "billing": [
        "billingSubmit",
        "couponCode",
        "formBillingValidationErrors"
    ],
    "search": [
        "viewSearchResults"
    ],
    "clp": [
        "genreBannerClick"
    ],
     "account": [
        "createAccountPage",
        "loginPageError",
        "registerPageError",
        "myAccountFormErrors",
        "myAccountFormPopupErrors"

    ],
    "checkoutlogin": [
        "checkoutGuestLogin",
        "loginPageError"
    ],
    "orderconfirmation": [
        "globale"
    ]
}